import { makeStyles } from '@material-ui/styles';
import { carmine } from 'styles/abstract/variables';

export const makeOrderTypeStyles = makeStyles(
    {
        orderType: {
            border: '0.0625rem solid transparent',
            transition: 'all 0.3s ease',

            '&.error': {
                border: `0.0625rem solid ${carmine}`,
            },
        },
    },
    { index: 1 },
);
